import * as ScrollMagic from 'scrollmagic';

export default class LazyLoader {
  constructor (el) {
    // init controller
    $(el).each( (index, fadeInElement) => {
      var controller = new ScrollMagic.Controller({globalSceneOptions: {
        duration: 0,
      }});
      // build scenes
      new ScrollMagic.Scene({
        triggerElement: fadeInElement,
        triggerHook: 'onEnter',
      })
      .setClassToggle(fadeInElement, "fade-in--show") // add class toggle
      //.addIndicators() // add indicators (requires plugin)
      .addTo(controller);
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/fade-animations.js